module.exports = __webpack_public_path__ + "img/co_ca.70f37c39.jpg";